import { Navbar, Container } from 'react-bootstrap';
import { useMsal } from '@azure/msal-react';
import logo from '../img/common/logo.png';

export const NavigationBar = () => {
    const { instance } = useMsal();
    let activeAccount;

    if (instance) {
        activeAccount = instance.getActiveAccount();
        console.log(activeAccount);
    }

    return (
        <>
            <Container>
                <Navbar bg="light" variant="dark" className="navbarStyle fixed-top p-0">
                    <div id="logo" className="collapse navbar-collapse justify-content-center">
                        <a className="navbar-brand p-1" href="/">
                            <img src={logo} alt="logo" />
                        </a>
                    </div>
                </Navbar>
            </Container>
        </>
    );
};
